interface Skill {
  name: string;
  icon: string;
  color: string;
}

interface SkillCategory {
  title: 'frontend' | 'backend' | 'architecture' | 'database' | 'observability' | 'ai' | 'messaging' | 'testing' | 'devops';
  skills: Skill[];
}

export const skillsData: SkillCategory[] = [
  {
    title: 'frontend',
    skills: [
      { name: "React", icon: "/images/skills/react.svg", color: "#61DAFB" },
      { name: "Next.js", icon: "/images/skills/nextjs.svg", color: "#000000" },
      { name: "TypeScript", icon: "/images/skills/typescript.svg", color: "#3178C6" },
      { name: "JavaScript", icon: "/images/skills/javascript.svg", color: "#F7DF1E" },
      { name: "HTML5", icon: "/images/skills/html5.svg", color: "#E34F26" },
      { name: "CSS3", icon: "/images/skills/css3.svg", color: "#1572B6" },
      { name: "Material UI", icon: "/images/skills/materialui.svg", color: "#007FFF" },
    ]
  },
  {
    title: 'backend',
    skills: [
      { name: "Node.js", icon: "/images/skills/nodejs.svg", color: "#339933" },
      { name: "NestJS", icon: "/images/skills/nestjs.svg", color: "#E0234E" },
      { name: "Go", icon: "/images/skills/go.svg", color: "#00ADD8" },
      { name: "gRPC", icon: "/images/skills/grpc.svg", color: "#244C5A" },
      { name: "Python", icon: "/images/skills/python.svg", color: "#3776AB" },
      { name: ".NET", icon: "/images/skills/dotnet.svg", color: "#512BD4" },
      { name: "Express", icon: "/images/skills/express.svg", color: "#000000" },
      { name: "GraphQL", icon: "/images/skills/graphql.svg", color: "#E10098" },
      { name: "REST APIs", icon: "/images/skills/rest-api.svg", color: "#0EA5E9" },
    ]
  },
  {
    title: 'architecture',
    skills: [
      { name: "Microservices", icon: "/images/skills/microservices.svg", color: "#6366F1" },
      { name: "DDD", icon: "/images/skills/ddd.svg", color: "#8B5CF6" },
      { name: "Clean Architecture", icon: "/images/skills/clean-architecture.svg", color: "#14B8A6" },
      { name: "SOLID", icon: "/images/skills/solid.svg", color: "#F59E0B" },
      { name: "CQRS", icon: "/images/skills/cqrs.svg", color: "#EC4899" },
      { name: "Event-Driven", icon: "/images/skills/event-driven.svg", color: "#06B6D4" },
    ]
  },
  {
    title: 'database',
    skills: [
      { name: "PostgreSQL", icon: "/images/skills/postgresql.svg", color: "#4169E1" },
      { name: "MongoDB", icon: "/images/skills/mongodb.svg", color: "#47A248" },
      { name: "MySQL", icon: "/images/skills/mysql.svg", color: "#4479A1" },
      { name: "Redis", icon: "/images/skills/redis.svg", color: "#DC382D" },
      { name: "DynamoDB", icon: "/images/skills/dynamodb.svg", color: "#FF9900" },
      { name: "SQL Server", icon: "/images/skills/sqlserver.svg", color: "#CC2927" },
      { name: "Oracle", icon: "/images/skills/oracle.svg", color: "#F80000" },
    ]
  },
  {
    title: 'observability',
    skills: [
      { name: "Application Insights", icon: "/images/skills/application-insights.svg", color: "#0078D4" },
      { name: "Grafana", icon: "/images/skills/grafana.svg", color: "#F46800" },
      { name: "Datadog", icon: "/images/skills/datadog.svg", color: "#632CA6" },
    ]
  },
  {
    title: 'ai',
    skills: [
      { name: "AI Tooling", icon: "/images/projects/ai-tooling.svg", color: "#8B5CF6" },
      { name: "AI Agents", icon: "/images/projects/ai-agents.svg", color: "#06B6D4" },
      { name: "Prompt Engineering", icon: "/images/projects/prompt-engineering.svg", color: "#F59E0B" },
      { name: "Codex", icon: "/images/projects/codex.svg", color: "#10A37F" },
      { name: "Claude Code", icon: "/images/projects/claude-code.svg", color: "#D97757" },
      { name: "Agentic Workflows", icon: "/images/projects/agentic-workflows.svg", color: "#EC4899" },
    ]
  },
  {
    title: 'messaging',
    skills: [
      { name: "RabbitMQ", icon: "/images/skills/rabbitmq.svg", color: "#FF6600" },
      { name: "Apache Kafka", icon: "/images/skills/kafka.svg", color: "#000000" },
      { name: "AWS SQS", icon: "/images/skills/aws-sqs.svg", color: "#FF4F8B" },
      { name: "AWS SNS", icon: "/images/skills/aws-sns.svg", color: "#FF4F8B" },
    ]
  },
  {
    title: 'testing',
    skills: [
      { name: "Jest", icon: "/images/skills/jest.svg", color: "#C21325" },
      { name: "Vitest", icon: "/images/skills/vitest.svg", color: "#729B1B" }
    ]
  },
  {
    title: 'devops',
    skills: [
      { name: "Docker", icon: "/images/skills/docker.svg", color: "#2496ED" },
      { name: "Git", icon: "/images/skills/git.svg", color: "#F05032" },
      { name: "AWS", icon: "/images/skills/aws.svg", color: "#FF9900" },
      { name: "Azure DevOps", icon: "/images/skills/azure.svg", color: "#0078D7" },
      { name: "CI/CD", icon: "/images/skills/cicd.svg", color: "#6366F1" },
      { name: "Linux", icon: "/images/skills/linux.svg", color: "#FCC624" },
    ]
  }
];
